import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import { typeSelfService } from './types';
import { GetSelfServiceContractInfoInput } from '../../apiTypes';

const resumeSelfServiceQuery = (): QueryInfos => {
    return {
        name: 'resumeSS',
        path: '/self-service/resume',
        type: typeSelfService.RESUME_SELFSERVICE,
        params: {},
    };
};

const getSelfServiceContractInfo = (variables: GetSelfServiceContractInfoInput): QueryInfos => {
    return {
        name: 'ssContractInfos',
        path: `/self-service/contracts/${variables.contractId}`,
        type: typeSelfService.GET_SELFSERVICE_CONTRACT_INFO,
        params: {},
    };
};

export function useResumeSelfService<T>(options?: Options<never>): UseQueryResult<T, Error> {
    return useMyQuery<T>(resumeSelfServiceQuery, options);
}

export function useGetSelfServiceContractInfo<T>(
    options?: Options<GetSelfServiceContractInfoInput>,
): UseQueryResult<T, Error> {
    return useMyQuery<T, GetSelfServiceContractInfoInput>(getSelfServiceContractInfo, options);
}
